// types.ts
import type {
  GModalCompareInitialValues,
  GModalConfirmInitialValues,
  GModalDeleteBulkInitialValues,
  GModalDeleteInitialValues,
  GModalDuplicateInitialValues,
  GModalSelectCampaignsInitialValues,
  GModalRenameInitialValues,
  GModalReviewPlanInitialValues,
  GModalTrialConfirmInitialValues,
  GModalOrderJourneyInitialValues,
  GModalExportInitialValues,
} from '~/presentation/common';
import type { GlobalSettingInitialValues } from '~/modules/global-setting/hooks/useGlobalSettingModal';
import type { ModalProps, TextFieldProps } from '@shopify/polaris';

export type GModalBaseProps = Omit<ModalProps, 'open' | 'onClose'>;

export interface GModalDefaultInitialValues {
  data: any;
}
export enum ModalType {
  RENAME = 'RENAME',
  DELETE = 'DELETE',
  DELETE_BULK = 'DELETE_BULK',
  CONFIRM = 'CONFIRM',
  DUPLICATE = 'DUPLICATE',
  DEFAULT = 'DEFAULT',
  GLOBAL_SETTING = 'GLOBAL_SETTING',
  COMPARE = 'COMPARE',
  SELECT_CAMPAIGNS = 'SELECT_CAMPAIGNS',
  REVIEW_PLAN = 'REVIEW_PLAN',
  TRIAL_CONFIRM = 'TRIAL_CONFIRM',
  ORDER_JOURNEY = 'ORDER_JOURNEY',
  EXPORT = 'EXPORT',
}

export type ModalInitialValuesMap = {
  [ModalType.RENAME]: GModalRenameInitialValues;
  [ModalType.DELETE]: GModalDeleteInitialValues;
  [ModalType.DELETE_BULK]: GModalDeleteBulkInitialValues;
  [ModalType.CONFIRM]: GModalConfirmInitialValues;
  [ModalType.DUPLICATE]: GModalDuplicateInitialValues;
  [ModalType.DEFAULT]: GModalDefaultInitialValues;
  [ModalType.GLOBAL_SETTING]: GlobalSettingInitialValues;
  [ModalType.COMPARE]: GModalCompareInitialValues;
  [ModalType.SELECT_CAMPAIGNS]: GModalSelectCampaignsInitialValues;
  [ModalType.REVIEW_PLAN]: GModalReviewPlanInitialValues;
  [ModalType.TRIAL_CONFIRM]: GModalTrialConfirmInitialValues;
  [ModalType.ORDER_JOURNEY]: GModalOrderJourneyInitialValues;
  [ModalType.EXPORT]: GModalExportInitialValues;
};

export type InitialValuesType<T extends ModalType> = T extends keyof ModalInitialValuesMap
  ? ModalInitialValuesMap[T]
  : never;

export type TGTextField = Partial<TextFieldProps>;
